<!-- src/components/Layout.vue -->
<template>
	<div>

		<el-header
			style="background-color: #545c64; display: flex; align-items: center; padding: 0 40px; justify-content: space-between;">
			<!-- 标题文字 -->
			<h1 style="color: #ffffff; font-family: 'Arial', sans-serif; font-size: 24px; margin: 0;">QIUI 开发者平台</h1>



			<div style="display: flex; align-items: center;">
				<el-dropdown @command="handleCommand">
					<div style="display: flex; align-items: center;">
						<!-- 左侧图标 -->
						<img src="../../../src/assets/app_logo.jpg" alt="Logo" style="height: 40px; margin-left: 20px;">

						<!-- 昵称 -->
						<span style="color: #ffffff; margin-left: 10px;">昵称</span>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="a">企业开发者账号认证</el-dropdown-item>
						<el-dropdown-item command="b">个人开发者账号认证</el-dropdown-item>
						<el-dropdown-item command="c">修改密码</el-dropdown-item>
						<el-dropdown-item divided command="d">退出账号</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

			</div>
		</el-header>

		<el-container style="background-color:#545c64;">
			<!-- 下面 -->
			<el-aside width="144px">
				<!-- 下面的左边 -->
				<el-menu default-active="/FirstPage" @select="handleSelect" class="el-menu-vertical-demo"
					background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">

					<el-menu-item index="/FirstPage">
						<i class="el-icon-s-custom"></i>
						<span slot="title">首页</span>
					</el-menu-item>

					<el-menu-item index="/FirstPage">
						<i class="el-icon-document"></i>
						<span slot="title">已入库设备</span>
					</el-menu-item>

					<el-menu-item index="/FirstPage">
						<i class="el-icon-setting"></i>
						<span slot="title">开发文档</span>
					</el-menu-item>


					<el-menu-item index="/FirstPage">
						<i class="el-icon-position"></i>
						<span slot="title">订单管理</span>
					</el-menu-item>

					<el-menu-item index="/FirstPage">
						<i class="el-icon-position"></i>
						<span slot="title">开发者商城</span>
					</el-menu-item>

					<el-menu-item index="/FirstPage">
						<i class="el-icon-position"></i>
						<span slot="title">账号设置</span>
					</el-menu-item>

				</el-menu>

			</el-aside>


			<el-main style="background-color: #ffffff; overflow: auto;">
				<!-- 下面的右边 -->
				<router-view></router-view>
			</el-main>

		</el-container>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';

	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {

			//默认打开的路由
			if (this.$route.path !== '/FirstPage') {
				this.$router.push({
					path: '/FirstPage',
					query: {}
				});
			}
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				isfirst: 0, //是否是第一次加载
				password: '',
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				if (this.$route.path !== key) { //同一个地址 不重复导航
					this.$router.push(key);
				}
			},
			handleCommand(command) { //菜单的点击
				switch (command) {
					case "a"://企业开发者认证
						console.log("企业开发者认证");
						break
					case "b"://个人开发者认证
						console.log("个人开发者认证");
						break
					case "c"://修改密码
						console.log("修改密码");
						break
					case "d": //处理退出账号的逻辑
						console.log("单击退出登录");
						Cookies.remove('tokenDevelopers'); // 清空 token
						this.$router.push({
							path: '/DevelopersLogin',
							query: {}
						});
						break
				}

			},
			//...
		}
	};
</script>

<style>
	h1 {
		margin: 0;
		color: #ddd;
	}
</style>